import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery, UseQueryOptions } from 'react-query'
import { Revision } from 'types'
import { sendToApi } from 'api/client'
import { layersKeys } from 'hooks/queries/layers/layersKeys'

interface Props {
  articleId: string
  layerId: string
  id: string
}

const fetchRevision = (articleId: string, layerId: string, id: string) =>
  sendToApi<{ revision: Revision }>(`/articles/${articleId}/layers/${layerId}/ai_revisions/${id}`)

export const useRevision = ({ articleId, layerId, id }: Props, options?: UseQueryOptions<{ revision: Revision }>) => {
  return useQuery<{ revision: Revision }>(
    layersKeys.revision(layerId, id),
    async () => {
      const res = await fetchRevision(articleId, layerId, id)
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      return res.data
    },
    {
      refetchOnWindowFocus: false,
      ...options,
    },
  )
}
